import { memo, MouseEvent } from 'react';

import { Button, ButtonProps } from '@components/button';
import { useEvent } from '@hooks/use-event';

import { useFormContext } from './form-provider';

type FormResetButtonProps = Omit<ButtonProps, 'id'>;

export const FormReset = memo<FormResetButtonProps>((props) => {
  const {
    store: { actions, useIsSubmitting },
  } = useFormContext();

  const handleClick = useEvent((event: MouseEvent<HTMLButtonElement>) => {
    actions.resetStore();
    props.onClick?.(event);
  });

  const isSubmitting = useIsSubmitting();

  return (
    <Button
      variant="secondary"
      isDisabled={isSubmitting}
      {...props}
      onClick={handleClick}
      type="button"
    />
  );
});

FormReset.displayName = 'Form.Reset';
